import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import IssueContainer from './IssueContainer';
import Loader from '../tracking/trackingLoading.gif';
import EmptyState from '../../../../common/EmptyState';
import EmptyStateText from './EmptyStateText';
import BearEmptyState from '../../../../../assets/bearEmpty.svg';
import { contactForm } from '../../../../../config/paths';
import { useIssuesListStyles } from './styles';

const IssuesList = ({ ...props }) => {
  const { issues, mobile, product, loading, error } = props;
  const classes = useIssuesListStyles();

  return (
    <Box margin={mobile ? '0px -16px' : ''}>
      {loading && <img className={classes.image} src={Loader} />}
      {!loading && error && (
        <EmptyState
          text={<EmptyStateText />}
          buttonText="Ir a formulario"
          image={BearEmptyState}
          mobile
          onClick={() => window.open(contactForm, '_blank')}
        />
      )}
      {!loading && !error && (
        <IssueContainer product={product} issues={issues} mobile={mobile} />
      )}
    </Box>
  );
};

IssuesList.propTypes = {
  issues: PropTypes.array,
  mobile: PropTypes.bool,
  product: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default IssuesList;
